import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { CustomElement, upgradeProperty, attachShadowTemplate } from '@tyler-components-web/core';
import { SWITCH_CONSTANTS } from './switch-constants';
import { SwitchFoundation } from './switch-foundation';
import { SwitchAdapter } from './switch-adapter';
import { ensureInputElement } from '../core';
var template = require('./switch.html');
var styles = require('./switch.css');
/**
 * The custom element class behind the `<tcw-switch>` element.
 */
var SwitchComponent = /** @class */ (function (_super) {
    __extends(SwitchComponent, _super);
    /** Constructs a switch component class */
    function SwitchComponent() {
        var _this = _super.call(this) /* istanbul ignore next */ || this;
        attachShadowTemplate(_this, SWITCH_CONSTANTS.elementName, template, styles);
        _this._foundation = new SwitchFoundation(new SwitchAdapter(_this));
        return _this;
    }
    Object.defineProperty(SwitchComponent, "observedAttributes", {
        get: function () {
            return [
                SWITCH_CONSTANTS.attributes.DENSE,
            ];
        },
        enumerable: true,
        configurable: true
    });
    /** Upgrades observed attributes */
    SwitchComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'dense');
    };
    SwitchComponent.prototype.connectedCallback = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ensureInputElement(this)];
                    case 1:
                        _a.sent();
                        this._foundation.connect();
                        return [2 /*return*/];
                }
            });
        });
    };
    SwitchComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case SWITCH_CONSTANTS.attributes.DENSE:
                this.dense = this.hasAttribute('dense') && this.getAttribute('dense') !== 'false';
                break;
        }
    };
    SwitchComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    Object.defineProperty(SwitchComponent.prototype, "dense", {
        /** Gets/sets whether the switch is dense. */
        get: function () {
            return this._foundation.dense;
        },
        set: function (value) {
            this._foundation.dense = value;
        },
        enumerable: true,
        configurable: true
    });
    SwitchComponent = __decorate([
        CustomElement({
            name: SWITCH_CONSTANTS.elementName
        })
    ], SwitchComponent);
    return SwitchComponent;
}(HTMLElement));
export { SwitchComponent };
